/**
 * CancerScreeningAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ScreeningStatus {
  Created = 0,
  RequestsSent = 1,
  SomeResultsArrived = 2,
  AllResultsArrived = 3,
  Completed = 4,
  Canceled = 5,
  SentToSkrin = 10,
}
export interface GetCancerScreeningsModel { 
    requestorSsn?: string;
    requestorName?: string;
    personName?: string;
    personSsn?: string;
    dateTimeFrom?: Date;
    dateTimeTo?: Date;
    specimenId?: string;
    screeningStatus?: Array<ScreeningStatus>;
}